import * as React from 'react'

const PhoneNumber = (props) => {
  return (
    <a className='phone-item' href='tel:0043800884404'>
      <p>01 907 68 85</p>
      <i className='fas fa-phone' />
    </a>
  )
}

export default PhoneNumber



// WEBPACK FOOTER //
// ./src/components/atoms/PhoneNumber.tsx